import { Link, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toggleSidebar } from '../features/uiSlice';
import { Home, GalleryVerticalEnd, Bookmark, Menu, Bell } from 'lucide-react';
import styles from '../css/MobileNavbar.module.css';

const MobileNavbar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const unreadCount = useSelector((s) => s.notifications.unreadCount);

  const isActive = (path) => location.pathname === path;

  const hideOnPaths = ['/login', '/register'];
  if (hideOnPaths.includes(location.pathname)) {
    return null;
  }

  return (
    <nav className={styles.mobileNavbar}>
      <Link to="/" className={`${styles.navItem} ${isActive('/') ? styles.active : ''}`}>
        <Home />
        <span>Главная</span>
      </Link>

      <Link to="/catalog" className={`${styles.navItem} ${isActive('/catalog') ? styles.active : ''}`}>
        <GalleryVerticalEnd />
        <span>Каталог</span>
      </Link>

      <Link to="/bookmarks" className={`${styles.navItem} ${isActive('/bookmarks') ? styles.active : ''}`}>
        <Bookmark />
        <span>Мое</span>
      </Link>

      <Link to="/notifications" className={`${styles.navItem} ${isActive('/notifications') ? styles.active : ''}`}>
        <span className={styles.bellWrapper}>
          <Bell size={24} fill="currentColor" strokeWidth={0} />
          {unreadCount > 0 && (
            <span className={styles.badge}>{unreadCount > 99 ? '99+' : unreadCount}</span>
          )}
        </span>
        <span>Уведы</span>
      </Link>

      <button className={styles.navItem} onClick={() => dispatch(toggleSidebar())}>
        <Menu />
        <span>Еще</span>
      </button>
    </nav>
  );
};

export default MobileNavbar;
